import { combineReducers } from 'redux';

// Import all Redux Toolkit slices
import authReducer from './auth/authSlice';
import userReducer from './user/userSlice';
import uiReducer from './ui/uiSlice';
import settingsReducer from './settings/settingsSlice';
import messageReducer from './message/messageSlice';
import streamChatReducer from './stream-chat/streamChatSlice';
import streamingReducer from './streaming/streamingSlice';
import followReducer from './follow/followSlice';
import playerReducer from './player/playerSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  ui: uiReducer,
  settings: settingsReducer,
  message: messageReducer,
  streamChat: streamChatReducer,
  streaming: streamingReducer,
  follow: followReducer,
  player: playerReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
